import { SidebarTypes } from "../../../interfaces/store/appStore"
import { selectConnectionsFilter, useConnectionsStore } from "../../../stores/connections/useConnectionsStore"
import { useSaveFiltersRequest } from "../../apis/save-filters/useSaveFiltersRequest"
import { useAppHandlers } from "../app/useAppHandlers"
import { useConnectionsHandlers } from "../connections/useConnectionsHandlers"


export const useSaveFilterHandlers = () => {

    const { getSavedFilters, saveFilters, removeFilters} = useSaveFiltersRequest()
    const { closeSidebar } = useAppHandlers()
    const { setScopedConnectionsFilterHandler: setConnectionsFilterHandler } = useConnectionsHandlers();
    const { store } = useConnectionsStore()
    const connectionsFilter = selectConnectionsFilter(store)

    const getSavedFiltersHandler = async() => {
        const result = await getSavedFilters()
        return result
    }
    

    const saveFiltersHandler = async (body: any) => {
        const result = await saveFilters(body)
        if (result) {
            closeSidebar(SidebarTypes.SAVE_FILTER);
            const updatedFilter = {
                ...connectionsFilter,
                savedFilter: !connectionsFilter.savedFilter,
                sortClicked: false
            };
            setConnectionsFilterHandler(updatedFilter);
        }
        return result
    }

    const removeFiltersHandler = async (filter: any) => {
        const result = await removeFilters(filter)
        return result
    }

    return {
        getSavedFiltersHandler,
        saveFiltersHandler,
        removeFiltersHandler
    }
}
